import React, { useEffect, useState } from "react";
import Footer from "components/user/Footer";
import Header from "components/user/Header";
import axios from "axios";
import banner from "../../../assets/img/banner.png";
import ListFaq from "components/user/faq/ListFaq";

function FAQ() {
  const [bannerImage, setBannerImage] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await axios.get(
          "/api_w/header?title=Frequently Asked Questions",
          {
            headers: {
              db_name: process.env.REACT_APP_DB_NAME,
            },
          }
        );
        const imageUrl = response.data.data.image_url;

        // Preload the image
        const img = new Image();
        img.src = imageUrl;

        // Set the banner image
        setBannerImage(imageUrl);
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBanner();
  }, []);

  return (
    <>
      <Header />
      <div className="relative top-[35px] mt-[30px] inline-flex h-auto w-full">
        {loading ? (
          <div className="flex h-auto w-full items-center justify-center">
            <p className="text-white">Loading...</p>
          </div>
        ) : (
          <>
            {bannerImage ? (
              <img className="h-auto w-full" src={bannerImage} alt="banner" />
            ) : (
              <img className="h-auto w-full" src={banner} alt="banner" />
            )}
            <div className="max-w-500 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform text-center font-bold text-black">
              <p className="text-xl md:text-4xl">
                Frequently Asked Questions Madrasah Jateng Digital Learning
              </p>
            </div>
          </>
        )}
      </div>

      <div className="mt-10 p-5">
        <ListFaq />
      </div>

      <Footer />
    </>
  );
}

export default FAQ;
